import type {
  IEmergencyContactAuditResponse,
  IStaffMemberAuditRecordResponse,
  IStaffMemberAuditSnapshotResponse,
} from '@loadedhub/core-api-sdk'
import { setCompanyTimeZone } from 'src/components/common/helpers/formatting/time-formatter/timeFormatter'

/**
 * The staff member as it was after one change, in the shape of the staff member
 * API model. Fields for the other country are empty, as are payroll fields for
 * a caller without the Payroll permission.
 */
export type StaffMemberAuditSnapshot = IStaffMemberAuditSnapshotResponse

/** Every dot path a field label may be keyed by */
export type StaffMemberAuditFieldPath =
  | keyof StaffMemberAuditSnapshot
  | `emergencyContact.${keyof IEmergencyContactAuditResponse}`

/**
 * One record as the UI shows it: the API record with occurredAt in the company
 * timezone and the staff member under the name the audit components expect
 */
export type StaffMemberAuditRecord = Omit<
  IStaffMemberAuditRecordResponse,
  'staffMember'
> & {
  snapshot?: StaffMemberAuditSnapshot
}

export const transformStaffMemberAuditRecordsOnGet = (
  records: IStaffMemberAuditRecordResponse[]
): StaffMemberAuditRecord[] =>
  records.map(({ staffMember, ...record }) => ({
    ...record,
    occurredAt: record.occurredAt
      ? setCompanyTimeZone(record.occurredAt)
      : undefined,
    snapshot: staffMember,
  }))
